$.fn.pastille = function(options) {
  let self = this;

  $(window).on('resize load orientationchange', function() {
    self.css('--pastille-width', self.find('.js-pastille').first().outerWidth() + 'px');
  })

  return function() {
    return self
  }()
}
